import styled from 'styled-components';
import Button from './Button';
const IconButton = styled(Button) `
    padding: 15px;

    .button__icon-wrapper {
        right: auto;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;
IconButton.defaultProps = {
    transparent: true,
};
export default IconButton;
